<template>
    <el-row>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="grid-stack-item">
            <div class="header">
                <h1>{{ $t('Edit Menu') }}</h1>
            </div>
            <div class="my-content">
                <div class="grid-stack-item-content">
                    <el-form :label-position="labelPosition" :model="menuForm" ref="menuForm" class="demo-menuForm">
                        <el-row :gutter="20">
                            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                                <el-form-item :label="$t('URL')" prop="url">
                                    <el-input v-model="menuForm.data.url"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('Menu Icon')" prop="menu_icon">
                                    <el-select v-model="menuForm.data.menu_icon" :placeholder="$t('Select menu icon')" clearable>
                                        <el-option v-for="icon in menu_icons" :key="icon.vaue" :label="icon.label" :value="icon.value"><i :class='icon.value'></i> {{ icon.label }}</el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="$t('Select Parent')" prop="parent_id">
                                    <el-select v-model="menuForm.data.parent_id" :placeholder="$t('Select parent menu')" clearable>
                                        <el-option v-for="item in menuForm.data.allMenu" :key="item.value" :label="item.title" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="$t('Category')" prop="category_id">
                                    <el-select v-model="menuForm.data.category_id" :placeholder="$t('Select category')">
                                        <el-option v-for="(item,key) in menu_types" :label="item" :key="item" :value="parseInt(key)"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="$t('Order Number')" prop="display_order">
                                    <el-input-number v-model="menuForm.data.display_order" :min="0" :max="10"></el-input-number>
                                </el-form-item>
                                <el-form-item :label="$t('Menu status')" prop="status">
                                    <el-radio-group v-model="menuForm.data.status">
                                        <el-radio :label="1">{{ $t('Enable') }}</el-radio>
                                        <el-radio :label="0">{{ $t('Disable') }}</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                                <el-card shadow="never">
                                    <el-tabs type="card" v-model="activeName" class="menu-tab">
                                        <el-tab-pane v-for="item in languages" :label="item.Text" :name="item.lang" v-bind:key="item.lang">
                                            <el-form-item :label="$t('Menu Title')" v-for="(lang, index) in menuForm.data.languages" v-bind:key="index" v-if="item.lang == lang.slug"
                                                prop="title">
                                                <el-input v-model="menuForm.data.languages[index].pivot.title"></el-input>
                                            </el-form-item>
                                            <el-form-item class="no-margin" :label="$t('Remark')" v-for="(lang, index) in menuForm.data.languages" v-bind:key="'remark'+index"
                                                v-if="item.lang == lang.slug" prop="remark">
                                                <el-input v-model="menuForm.data.languages[index].pivot.remark"></el-input>
                                            </el-form-item>
                                        </el-tab-pane>
                                    </el-tabs>
                                </el-card>
                            </el-col>
                            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <el-form-item class="no-margin">
                                    <el-button type="primary" @click="submitForm('menuForm')">{{ $t('Save') }}</el-button>
                                    <router-link tag="el-button" to="/menu" class="el-button--cancel">{{ $t('Cancel') }}</router-link>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </div>
        </el-col>
    </el-row>
</template>
<script>
    export default {
        data() {
            return {
                activeName: "en",
                labelPosition: "top",
                languages: process.env.KIPAKI_languages,
                menu_types: process.env.KIPAKI_menu_types,
                menu_icons: process.env.KIPAKI_menu_icons,
                menuForm: {
                    data: {
                        menuItem: {}
                    }
                }
            };
        },
        mounted() {
            request({
                    url: "menu-items/" + this.$route.params.id,
                    method: "get",
                    params: {}
                })
                .then(response => {
                    this.menuForm = response.data;
                    if(this.menuForm.data.parent_id == 0){
                        this.menuForm.data.parent_id = null;
                    }
                })
                .catch(error => {});
        },
        methods: {
            submitForm(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        request({
                                url: "menu-items/" + this.$route.params.id,
                                method: "patch",
                                data: this.menuForm.data
                            })
                            .then(response => {
                                this.$notify({
                                    title: this.$t('Success'),
                                    message: response.data.message,
                                    type: "success",
                                    offset: 50
                                });
                                serverBus.$emit("menuItems");
                            })
                            .catch(error => {
                                this.$notify({
                                    title: this.$t('Error'),
                                    message: error.response.data.message,
                                    type: "error",
                                    offset: 50
                                });
                            });
                    }
                });
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/Layout/Menu/EditMenu.vue